import { render, staticRenderFns } from "./bind-client-applet.vue?vue&type=template&id=cb0bff72&scoped=true"
import script from "./bind-client-applet.vue?vue&type=script&lang=js"
export * from "./bind-client-applet.vue?vue&type=script&lang=js"
import style0 from "./bind-client-applet.vue?vue&type=style&index=0&id=cb0bff72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0bff72",
  null
  
)

export default component.exports